<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "用户数据调试",
      items: [
        {
          text: "调试",
          active: true,
        },
      ],
      userData: null,
      permissionData: null
    };
  },
  mounted() {
    // 获取localStorage中的用户数据
    const userStr = localStorage.getItem('user');
    if (userStr) {
      this.userData = JSON.parse(userStr);
    }
    
    // 获取权限管理器数据
    this.permissionData = {
      user: this.$permission.user,
      roleId: this.$permission.roleId,
      permissions: this.$permission.permissions,
      userRole: this.$permission.getUserRole(),
      userPermissions: this.$permission.getUserPermissions()
    };
    
    console.log('用户数据:', this.userData);
    console.log('权限数据:', this.permissionData);
  },
  methods: {
    // 手动设置admin用户为超级管理员
    setAdminAsSuperAdmin() {
      if (this.userData) {
        this.userData.roleid = 0;
        this.userData.roleId = 0;
        this.userData.topuid = 0; // 主账号无上级
        localStorage.setItem('user', JSON.stringify(this.userData));
        
        // 刷新权限管理器
        this.$permission.refresh();
        
        // 重新获取权限数据
        this.permissionData = {
          user: this.$permission.user,
          roleId: this.$permission.roleId,
          permissions: this.$permission.permissions,
          userRole: this.$permission.getUserRole(),
          userPermissions: this.$permission.getUserPermissions()
        };
        
        this.$message.success('已设置admin为超级管理员 (roleid: 0)，请刷新页面');
      }
    },
    
    // 手动设置admin用户为管理员
    setAdminAsAdmin() {
      if (this.userData) {
        this.userData.roleid = 1;
        this.userData.roleId = 1;
        this.userData.topuid = 0;
        localStorage.setItem('user', JSON.stringify(this.userData));
        
        // 刷新权限管理器
        this.$permission.refresh();
        
        // 重新获取权限数据
        this.permissionData = {
          user: this.$permission.user,
          roleId: this.$permission.roleId,
          permissions: this.$permission.permissions,
          userRole: this.$permission.getUserRole(),
          userPermissions: this.$permission.getUserPermissions()
        };
        
        this.$message.success('已设置admin为管理员 (roleid: 1)，请刷新页面');
      }
    },
    
    // 手动设置admin用户为受限用户
    setAdminAsLimited() {
      if (this.userData) {
        this.userData.roleid = 2;
        this.userData.roleId = 2;
        this.userData.topuid = 0;
        localStorage.setItem('user', JSON.stringify(this.userData));
        
        // 刷新权限管理器
        this.$permission.refresh();
        
        // 重新获取权限数据
        this.permissionData = {
          user: this.$permission.user,
          roleId: this.$permission.roleId,
          permissions: this.$permission.permissions,
          userRole: this.$permission.getUserRole(),
          userPermissions: this.$permission.getUserPermissions()
        };
        
        this.$message.success('已设置admin为受限用户 (roleid: 2)，请刷新页面');
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h5 class="card-title mb-0">用户数据调试</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <h6>localStorage中的用户数据</h6>
                <pre class="bg-light p-3">{{ JSON.stringify(userData, null, 2) }}</pre>
              </div>
              <div class="col-md-6">
                <h6>权限管理器数据</h6>
                <pre class="bg-light p-3">{{ JSON.stringify(permissionData, null, 2) }}</pre>
              </div>
            </div>
            
            <div class="row mt-4">
              <div class="col-12">
                <h6>快速修复</h6>
                <div class="alert alert-warning">
                  <strong>注意：</strong>权限组用 roleid；topuid 仅表示上级账号（主账号为 0）：
                  <ul class="mb-0 mt-2">
                    <li><strong>roleid = 0:</strong> 超级管理员</li>
                    <li><strong>roleid = 1:</strong> 管理员</li>
                    <li><strong>roleid >= 2:</strong> 操作员/只读/门店等</li>
                  </ul>
                </div>
                <div class="btn-group">
                  <el-button type="danger" @click="setAdminAsSuperAdmin">
                    设置为超级管理员 (roleid: 0)
                  </el-button>
                  <el-button type="primary" @click="setAdminAsAdmin">
                    设置为管理员 (roleid: 1)
                  </el-button>
                  <el-button type="warning" @click="setAdminAsLimited">
                    设置为受限用户 (roleid: 2)
                  </el-button>
                </div>
              </div>
            </div>
            
            <div class="row mt-4">
              <div class="col-12">
                <h6>权限测试</h6>
                <div class="row">
                  <div class="col-md-3">
                    <el-button v-permission="'admin.view'" type="primary" size="small">
                      管理员查看
                    </el-button>
                  </div>
                  <div class="col-md-3">
                    <el-button v-permission="'admin.edit'" type="success" size="small">
                      管理员编辑
                    </el-button>
                  </div>
                  <div class="col-md-3">
                    <el-button v-permission="'admin.delete'" type="danger" size="small">
                      管理员删除
                    </el-button>
                  </div>
                  <div class="col-md-3">
                    <el-button v-permission="'permission.view'" type="warning" size="small">
                      权限查看
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
pre {
  font-size: 0.875rem;
  max-height: 300px;
  overflow-y: auto;
}
</style>
